module.exports = __webpack_public_path__ + "media/images/icons/icon_report-0b3813c0084e281fb929b4ca1cc10a4a.svg";